import { createSetSearchResults } from './setSearchResults';
import { filteredResultsVar, searchResultsVar } from '../reactiveVariables';

const setSearchResults = createSetSearchResults(filteredResultsVar, searchResultsVar);

export default setSearchResults;
